<template>
  <div class="contribute">
    <div class="contribute-actions">
      <button type="button" class="tasks-btn" @click="showTasks = true">
        {{ t('halloween.taskTitle') }}
      </button>
      <button type="button" class="strike-btn" :disabled="!canPlay" @click="emit('strike')">
        <span class="strike-btn-text">
          {{ t('halloween.strike') }}
        </span>
      </button>
      <button type="button" class="record-btn" @click="openRecords">
        {{ t('halloween.recordTitle') }}
      </button>
    </div>
    <p class="contribute-desc">{{ t('halloween.contributeDesc') }}</p>
    <p class="contribute-count">{{ t('halloween.available') }}：{{ availableCount }}</p>

    <MissionDialog
      v-model="showTasks"
      :tasks="tasks"
      :can-play="canPlay"
      @share="emit('share')"
      @receive="emit('receive-task', $event)"
    />
    <RecordDialog v-model="showRecords" :records="records" />
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'
import RecordDialog from '../Dialog/RecordDialog/index.vue'
import MissionDialog from '../Dialog/MissionDialog/index.vue'

const props = defineProps({
  tasks: {
    type: Array,
    default: () => [],
  },
  records: {
    type: Array,
    default: () => [],
  },
  canPlay: {
    type: Boolean,
    default: false,
  },
  loggedIn: {
    type: Boolean,
    default: false,
  },
  availableCount: {
    type: Number,
    default: 0,
  },
})
const emit = defineEmits(['strike', 'share', 'receive-task', 'open-records'])
const { t } = useI18n()
const showTasks = ref(false)
const showRecords = ref(false)

const openRecords = () => {
  emit('open-records')
  if (props.loggedIn) showRecords.value = true
}
</script>

<style lang="less" scoped>
.contribute {
  
}

.contribute-actions {
  display: flex;
  justify-content: center;
  gap: 25px;
  margin-top: 20px;
  
  .tasks-btn, .record-btn {
    border: 0;
    background-color: transparent;
    width: 186px;
    height: 104px;
    background: url('~@/views/act/halloween/assets/img/tasks-btn.png') no-repeat center center / 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 23px;
    font-weight: bold;
    color: #22012A;
    padding: 0;
    padding: 0 20px;
    padding-top: 10px;
  }
  .strike-btn {
    border: 0;
    background-color: transparent;
    width: 293px;
    height: 101px;
    background: url('~@/views/act/halloween/assets/img/strike-btn.png') no-repeat center center / 100% 100%;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .strike-btn-text {
      font-size: 50px;
      font-weight: bold;
      // color: #D95700;
      background: linear-gradient(to bottom, #D95700, #FFA200);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      filter: drop-shadow(0 2px 0 #fff);
    }
  }
}

.contribute-desc,
.contribute-count {
  padding: 0 20px;
  margin: 16px 0 0;
  font-size: 20px;
  text-align: center;
  white-space: pre-line;
}
</style>
